export const Image = {
  aspect_ratio: 0,
  height: 0,
  iso_639_1: "",
  file_path: "",
  vote_average: 0,
  vote_count: 0,
  width: 0,
};

export const Images = {
  backdrops: [],
  logos: [],
  posters: [],
};
